import React from 'react'
import { GoArrowLeft } from 'react-icons/go';
import { HiArrowRight } from 'react-icons/hi'


const Pagination2 = ({currentPage, setCurrentPage, totalPages}) => {
	const getVisiblePages = () => {
		const visiblePages = [];
		const maxVisiblePages = 15; // Adjust as needed
		let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
		const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

		if (endPage - startPage + 1 < maxVisiblePages) {
			startPage = Math.max(1, endPage - maxVisiblePages + 1);
		}

		for (let i = startPage; i <= endPage; i++) {
			visiblePages.push(i);
		}

		return visiblePages;
	};

	const pages = getVisiblePages();

	// const pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

	const handlePage = (item) => {
		setCurrentPage(item);
	};

	const handleForward = () => {
		if (currentPage && currentPage !== totalPages) {
			setCurrentPage(currentPage + 1);
		} else {
			console.log("no questions in this batch");
		}
	};

	const handleBackward = () => {
		if (currentPage && currentPage > 1) {
			setCurrentPage(currentPage - 1);
		} else {
			console.log("cannot go below that");
		}
	};
	return (
		<div className='sticky bottom-0 flex items-start justify-between w-full border-[1px] border-[#DDE1E6] bg-white z-10 rounded-md py-2 px-1.5 md:py-2.5 md:px-4 lg:py-3 lg:px-5 xl:px-6'>
			{/* PREVIOUS */}
            <div onClick={handleBackward}
                className={`flex items-center py-1 px-1 border-[1px] border-[#DDE1E6] rounded cursor-pointer text-[#25A249] hover:bg-[#25A249] hover:text-white xl:py-1.5 
                            xl:px-2.5 xl:rounded-md ${
														currentPage === 1
															? "opacity-30 cursor-not-allowed"
															: "hover:[#25A249]"
													}`}>
                <GoArrowLeft className='text-[10px] md:text-[12px] xl:text-base' />
                <p className='text-[8px] pl-1 hover:text-[#FFFFFF] md:text-[10px] lg:pl-1.5 xl:text-[12px]'>
                    Previous
                </p>
            </div>

            
			<div className='flex items-center justify-center flex-wrap px-[3px]'>
				{pages.map((item, index) => (
					<div
						key={index}
						onClick={() => handlePage(item)}
                        className={`flex items-center justify-center h-5 w-5 rounded 
                            cursor-pointer md:mx-[2px] xl:mx-1 xl:h-6 xl:w-6 ${item === currentPage ? "bg-[#DCF0E2]" : "bg-[#ffffff]"}`}
					>
                        <p className={`text-[9px] md:text-[10px] xl:text-[12px] ${item === currentPage ? 'text-[#25A249]' : 'text-[#53545C]'}`}>
                            {item}
                        </p>
					</div>
				))}

				{
					<>
						{totalPages > pages[pages.length - 1] && (
							<span className='mx-2 text-[#667085]'>...</span>
						)}
					</>
				}

				{currentPage < totalPages - 1 && (
					<div
						onClick={() => handlePage(totalPages)}
						className={`flex items-center justify-center py-1.5 px-3 rounded-md cursor-pointer ${
							totalPages === currentPage ? "bg-[#C3EFE4]" : "bg-[#ffffff]"
						}`}
					>
						<p
							className={`text-[9px] font-semibold lg:text-[10px] xl:text-[11px] ${
								totalPages === currentPage ? "text-primary" : "text-[#999999]"
							}`}
						>
							{totalPages}
						</p>
					</div>
				)}
			</div>

            
            {/* NEXT */}
			<div
				onClick={handleForward}
				className={`flex items-center py-1 px-1 border-[1px] border-[#DDE1E6] rounded cursor-pointer text-[#25A249] hover:bg-[#25A249] hover:text-white xl:py-1.5 
                            xl:px-2.5 xl:rounded-md ${
														currentPage === totalPages
															? "opacity-30 cursor-not-allowed"
															: "hover:[#25A249]"
													}`}
			>
				<p className='text-texts text-[8px] font-medium lg:text-[11px] xl:text-xs'>
					Next
				</p>
				<HiArrowRight className='text-texts text-[10px] lg:text-sm' />
			</div>
		</div>
	);
};

export default Pagination2
